import React, { useRef, useEffect, useState } from 'react';


const LobbyNoMinCard = (props) => {

        // HANDLES WHEN PERSON ENTERS LOBBY WITHOUT MIN PLAYERS BEING MET

    return (
        <>

            <div className='game-card taken-card ' >

                <div className='game-card-header'>
                    <div className='game-card-header-left'>
                        <h3 className={'game-track taken-track'}><span>{props.trackNum}</span></h3>
                        <div className='game-card-title'>
                            <h4>Collecting Players...</h4>

                        </div>
                    </div>

                    <div className='game-card-header-right'>

                    </div>
                </div>

                <div className='game-card-body'>
                
                    
                    <div className={'claim-mode waiting-theMode'}>
                        <p style={{fontSize:"12px", fontWeight:600, color:"white"}}>3 players are needed to start</p>
                        <p style={{fontSize:"12px", textAlign:"center"}}>All games are final. No refunds.</p>
                    </div>

                </div>

                    {
                        <p ><i style={{color: "var(--main-color)"}}  className='material-icons'>groups</i>Total Players {props.players}</p>                    }
            </div>


        </>
    );

}

export default LobbyNoMinCard